const React = require("react");
const LoginStore = require("../../stores/LoginStore");

class Header extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
        logoUrl: "",
      };
      this._onCdnAssetChange = this._onCdnAssetChange.bind(this);
  }
  componentDidMount() {
    LoginStore.addChangeListener(this._onCdnAssetChange);
    this.favicon = document.getElementById("favicon");
  }

  _onCdnAssetChange() {
    let appState = LoginStore.getState();
    if (appState.brandInfoItem) {
      this.setState({
        srcLogoUrl: appState.brandInfoItem.srcLogoUrl,
        faviconUrl: appState.brandInfoItem.faviconUrl,
        logoLink: appState.brandInfoItem.logoLink,
        deviantLogoCss: appState.brandInfoItem.deviantLogoCss,
      });
    }
  }

  componentDidUpdate() {
    if (this.favicon) {
      this.favicon.href = this.state.faviconUrl
        ? this.state.faviconUrl
        : "/web/assets/images/favicon.ico";
    }
  }

  render() {
    const { removeNavbar } = this.props;
    const brandIdentifier = window.location.hostname.includes("makro") ? '/web/assets/images/makro.png' : this.state.srcLogoUrl;
    const logoMakro= window.location.hostname.includes("makro") ? "logoMakro" : '';
    if (removeNavbar) {
      return (
        <div className={this.state.srcLogoUrl ? "logoContainer" : "hide"} role="banner">
          <div className="logo">
            <a href={this.state.logoLink}>
              <img
                className="responsiveImage"
                alt="Metro"
                src={this.state.srcLogoUrl}
              />
            </a>
          </div>
        </div>
      );
    }
    return (
      <div
        className={
          this.state.srcLogoUrl ? "app-navbar navbar-fixed-top" : "hide"
        }
        name="header"
      >
        <div className="col-md-1 col-xs-0"></div>
        <div className="col-md-2 col-xs-4 headerImage">
          <a href={this.state.logoLink}>
            <img
              className={
                this.state.deviantLogoCss
                  ? "deviantLogoResolution img-responsive"
                  : `headerResulation img-responsive ${logoMakro}`
              }
              id="header_logo_img"
              alt="Metro"
              src={brandIdentifier}
            />
          </a>
        </div>
        <div className="col-md-6 col-xs-1"></div>
        <div className="col-md-1 col-xs-1"></div>
      </div>
    );
  }
}

module.exports = Header;
